

import React, { useEffect, useState } from 'react';
import { Form, Input, Modal, Space, Table, Tag } from 'antd';
import { HistoryTable } from '../../../Services/LocomotiveServices';
import { id } from 'date-fns/locale';
import { Link, useHistory, useLocation } from 'react-router-dom';
import DynamicTable from '../../../Components/TableComponents/DynamicTable';
import moment from 'moment';


const LocomotiveHistoryTable = ({ flag, data, setData }) => {
  const { state, newdata } = useLocation()
  const history = useHistory();
  const [modalVisible, setModalVisible] = useState(false); // State for modal visibility
  const [form] = Form.useForm()

  const handleModalOpen = (record) => {

    form.setFieldsValue({
      PartType: record?.PartType,
      PartNbr: record?.PartNbr,
      PartSerialNbr: record?.PartSerialNbr
    })
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
  };
  const tableData = {
    header: [
      // "UNIT NUMBER",
      "LOCATION",
      "REPAIRS NEEDED",
      "REPAIRS MADE",
      // "REL-RR- OOS",
      'DATE COMPLETED',
      'REPAIRED BY',
      'POS',
      'REF'
    ],
    rows: data?.map(record =>
      [
        { value: record?.Location || '-', style: { width: "100px" } },
        { value: record?.RepairNeeded || '-', style: { width: "200px", lineBreak: "anywhere" } },
        {
          value: <span>
            {record?.RepairMade} {record?.PartNbr && (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleModalOpen(record);
                }}
              >
                ({record?.PartNbr})
              </a>
            )}
          </span>, style: { width: "250px", lineBreak: "anywhere" }
        },
        { value: moment(record?.WorkCompleted)?.utc().format('MM-DD-YYYY') || '-', style: { width: "100px" } }, // Format to display only date
        { value: record?.RepairedBy || '-', style: { width: "100px", lineBreak: "anywhere" } },
        { value: record?.POS || '-', style: { width: "50px" } },
        {
          value: record?.WOID ? (
            <a
              style={{ cursor: 'pointer' }}
              onClick={() => history.push('/Locomotive-work-order-edit', { id: record.WOID })}
            >
              {record.WOID}
            </a >
          ) : (
            '-'
          ), style: { width: "50px" }
        },
      ]
    )
  };
  return (
    <>
      <DynamicTable tableData={tableData} pagesToShow={[15, 30, 60, 100]} customRowsPerPage={15} pageFor='history' />
      <Modal

        title={<span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800' }}>Part Info</span>}

        visible={modalVisible}
        onCancel={handleModalClose}
        footer={null}
      >
        {/* Modal content goes here */}
        <Form
          form={form}
          name="basic"
          labelCol={{
            span: 7,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 800,
          }}
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
          labelAlign='left'
        // onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label="Part Type"
            name='PartType'
            rules={[
              {
                required: true,
                message: 'Please input your username!',
              },
            ]}
          >
            {/* <Input defaultValue={data.length > 0 ? data[0].PartType : ''} /> */}
            <Input disabled style={{ color: 'black' }} />
          </Form.Item>
          <Form.Item
            label="Part Number"
            name='PartNbr'
            rules={[
              {
                required: true,
                message: 'Please input your username!',
              },
            ]}
          >
            <Input disabled style={{ color: 'black' }} />
          </Form.Item>
          <Form.Item
            label="Part Serial Number"
            name='PartSerialNbr'
            rules={[
              {
                required: true,
                message: 'Please input your username!',
              },
            ]}
          >
            <Input disabled style={{ color: 'black' }} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
export default LocomotiveHistoryTable;